<template>
  <section class="promotion-details">
    <h2 class="page-title">優惠活動詳情</h2>
    <div class="promotion-list">
      <div v-for="promo in promotions" :key="promo.id" class="promotion-item" @click="goPromotionDetail(promo)">
        <div class="promotion-info">
          <span class="promotion-date item-text-bold">{{ formatISODateToCustom(promo.updated_at) }}</span>
              <div class=" item-text-bold promo-cell">
                <!-- <span class="promotion-title">{{ promo.title }}</span> -->
                 {{ promo.title }}
              </div>
        </div>
        <img :src="getFullImageURL(promo.offer_image)" :alt="promo.title" class="promotion-image"
          @error="onImageError" />
      </div>
    </div>

    <!-- Use the Pagination component -->
    <ThePagination :total="totalItems" :current="currentPage" :perPage="itemsPerPage" :visiblePageCount="5"
      @page-changed="onPageChanged" />
    <div style="height:1px"></div>
  </section>
</template>

<script>
import { onImageError, getFullImageURL, formatISODateToCustom } from '@/util/util';
import { globalParams } from '@/global';
import PullDAO from '@/services/PullDAO';
import ThePagination from '@/components/ThePagination.vue';

export default {
  name: 'PromotionDetails',
  components: {
    ThePagination,
  },
  data() {
    return {
      promotions: [],
      isLoading: false,
      error: null,
      itemsPerPage: 6, // Number of offers per page
      currentPage: 1,  // Current page
      totalItems: 0,   // Total number of promotions
    };
  },
  methods: {
    formatISODateToCustom,
    onImageError,
    getFullImageURL,
    async fetchAllOffers() {
      this.isLoading = true;
      this.error = null;

      const pullDAO = new PullDAO();

      try {
        const resp = await pullDAO.listOffers(this.itemsPerPage, this.currentPage);
        this.promotions = resp.offers;
        this.totalItems = resp.total; // Ensure your API returns this
      } catch (err) {
        this.error = err.message || '無法加載優惠活動。';
      } finally {
        this.isLoading = false;
      }
    },
    goPromotionDetail(promo) {
      globalParams.shownPromotion = promo;
      globalParams.promotion_promotions = this.promotions;
      globalParams.promotion_currentPage = this.currentPage;
      globalParams.promotion_totalItems = this.totalItems;

      this.$router.push("/promotion-detail");
    },
    onPageChanged(newPage) {
      this.currentPage = newPage;
      this.fetchAllOffers();
    },
  },
  mounted() {
    if (globalParams.promotion_promotions) {
      // alert('has promotion_promotions');
      this.promotions = globalParams.promotion_promotions;
      this.currentPage = globalParams.promotion_currentPage;
      this.totalItems = globalParams.promotion_totalItems;
    } else {
      this.fetchAllOffers();
    }

  },
};
</script>

<style scoped>
.promotion-details {
  margin: 0 auto;
  text-align: center;
  /* width: var(--home-component-width); */
  width:100%;
  background-color: var(--background-gray);
  min-height: 100vh;
}

.promotion-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;

  width:1416px;
  margin: 0 auto;
}

.promotion-item {
  display: flex;
  flex-direction: row;
  /* justify-content: space-between; */
  align-items: center;
  padding: 20px 30px;
  background-color: white;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  /* max-width: 1200px; */
  box-sizing: border-box;
}

.promotion-info {
  display: flex;
  align-items: center;
  gap: 60px;
  flex-grow: 1;
}

.promotion-date {
  font-weight: bold;
  font-size: calc(1rem + 0.2vw);

  color: var(--green03);
}

.promo-cell {
  color: var(--gray15);
}

.promotion-image {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 10px;
  margin-left: 20px;
}

/* RWD styles for screens smaller than 560px */
@media (max-width: 560px) {
  .promotion-details {
    width: 100%;
    padding: 20px 0;
  }

  .promotion-list {
    gap: 15px;

    width: 343px;
  }

  .promotion-item {
    padding: 15px;
    width: 343px;
    border-radius: 10px;
  }

  .item-text-bold {
    margin-top: 0;
    margin-bottom: 0;

    text-align: left;
   
  }

  .promotion-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    width:160px;
    height: 80px;
    /* overflow: hidden; */
    /* text-overflow: ellipsis; */
  }

   .promo-cell {
    width: 225px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    margin-top: 0px;

    color: var(--gray15);
    /* background-color: red; */
  }

  .promotion-date {
    /* font-size: 0.8rem; */
    margin-bottom: 0px;
  }

  .promotion-title {
    font-size: 1rem;
    /* overflow: hidden; */
    white-space: nowrap;
    /* Prevent text from wrapping */
    /* overflow: hidden; */
    /* Hide overflow text */
  }

  .promotion-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 10px;
    margin-left: 10px;
  }
}
</style>
